import { useContext } from 'react';
import { PreloadContext } from '../../../../shared/context/PreloadContext';

export function useIsRosaIntegrationEnabled(): boolean {
	const { isRosaIntegrationEnabled } = useContext(PreloadContext);
	return isRosaIntegrationEnabled;
}
